export const hr = {
  // Common
  common: {
    save: 'Spremi',
    cancel: 'Odustani',
    delete: 'Izbriši',
    edit: 'Uredi',
    add: 'Dodaj',
    search: 'Pretraži',
    searchGroups: 'Pretraži grupe...',
    searchVehicles: 'Pretraži vozila...',
    noGroupsFound: 'Nema pronađenih grupa',
    noVehiclesFound: 'Nema pronađenih vozila',
    searchDrivers: 'Pretraži vozače...',
    noDriversFound: 'Nema pronađenih vozača',
    loading: 'Učitavanje...',
    noData: 'Nema podataka',
    today: 'Danas',
    yesterday: 'Jučer',
    thisWeek: 'Ovaj tjedan',
    last7Days: 'Posljednjih 7 dana',
    last30Days: 'Posljednjih 30 dana',
    thisMonth: 'Ovaj mjesec',
    customRange: 'Prilagođeno razdoblje',
    backToPresets: 'Natrag na razdoblja',
    all: 'Sve',
    showing: 'Prikazano',
    to: 'do',
    of: 'od',
    entries: 'unosa',
    page: 'Stranica',
    rows: 'redova',
    refresh: 'Osveži',
    selectAll: 'Odaberi sve',
    selectRow: 'Odaberi red',
    pageNotFound: 'Ups! Stranica nije pronađena',
    returnToHome: 'Povratak na početnu',
    kilometersShort: 'km',
    kilometersPerHourShort: 'km/h',
    litersShort: 'L',
    litersPer100KmShort: 'L/100km',
    exportFailed: 'Izvoz nije uspio',
    exportPdf: 'Izvezi PDF',
    exportExcel: 'Izvezi Excel',
    pdfExported: 'PDF izvezen',
    excelExported: 'Excel izvezen',
    exportSuccess: 'je uspješno preuzet.',
    dateRangeLabel: 'Opseg datuma',
    generatedLabel: 'Generisano',
    exportedBy: 'Izvezao',
    totalsLabel: 'Ukupno',
    records: 'zapisa',
    total: 'Ukupno',
    hoursShort: 'h',
    minutesShort: 'm',
    secondsShort: 's',
    percentSymbol: '%',
    previous: 'Prethodno',
    next: 'Sljedeće',
    more: 'Više',
    morePages: 'Još stranica',
    close: 'Zatvori',
    toggleSidebar: 'Prikaži/sakrij meni',
    previousSlide: 'Prethodni slajd',
    nextSlide: 'Sledeći slajd',
    pagination: 'Paginacija',
    breadcrumb: 'Putanja',
  },

  // Navigation
  nav: {
    liveTracking: 'Praćenje uživo',
    history: 'Povijest',
    vehicles: 'Vozila',
    drivers: 'Vozači',
    zones: 'Zone',
    poi: 'Tačke interesa',
    reports: 'Izvješća',
    notifications: 'Obavijesti',
    costs: 'Troškovi',
    editProfile: 'Uredi profil',
    editProfileDesc: 'Izmijenite ime, kontaktne podatke i lozinku',
    profileUpdated: 'Profil je ažuriran',
    userSettings: 'Postavke korisnika',
    systemSettings: 'Sistemske postavke',
    signOut: 'Odjava',
    language: 'Jezik',
    settings: 'Postavke',
    groups: 'Grupe',
    users: 'Korisnici',
    activity: 'Dnevnik aktivnosti',
    scheduledReports: 'Zakazana izvješća',
  },

  // Auth
  auth: {
    welcomeBack: 'Dobrodošli nazad',
    signInToContinue: 'Prijavite se na svoj nalog da nastavite',
    username: 'Korisničko ime',
    email: 'Email',
    password: 'Lozinka',
    signIn: 'Prijava',
    signingIn: 'Prijavljivanje...',
    fleetManagementSystem: 'Sistem za upravljanje flotom',
    demoCredentials: 'Demo: Koristite bilo koji email i lozinku (min 6 karaktera)',
    invalidCredentials: 'Pogrešni podaci za prijavu',
    enterCredentials: 'Molimo unesite vaše podatke',
    passwordMinLength: 'Lozinka mora imati najmanje 6 karaktera',
    sessionExpired: 'Vaša sesija je istekla. Prijavite se ponovo.',
    appName: 'Global GPS',
    usernamePlaceholder: 'korisničko ime',
    passwordPlaceholder: '••••••••',
    realTimeGpsTracking: 'GPS praćenje u realnom vremenu',
    monitorFleet247: 'Pratite vašu flotu 24/7',
    routeHistory: 'Povijest ruta',
    detailedVehicleData: 'Detaljni podaci o vozilu za svaku vožnju',
    enterpriseSecurity: 'Sigurnost za poduzeća',
    encryptedDataRoleBasedAccess: 'Šifrirani podaci i pristup po ulogama',
    pro: 'Pro',
  },

  apiErrors: {
    invalid_preferences: 'Postavke obavijesti nije moguće spremiti',
    missing_credentials: 'Korisničko ime i lozinka su obavezni',
    invalid_credentials: 'Pogrešno korisničko ime ili lozinka',
    missing_api_key: 'Prijavite se da biste nastavili',
    invalid_token: 'Vaša sesija je istekla. Prijavite se ponovo.',
    invalid_user: 'Korisnički nalog nije pronađen',
    group_in_use: 'Grupa se ne može obrisati dok su korisnici ili vozila dodeljeni',
    username_exists: 'Korisničko ime već postoji',
    cannot_delete_self: 'Ne možete obrisati vlastiti nalog',
    not_found: 'Traženi resurs nije pronađen',
    forbidden: 'Nemate dopuštenje za ovu radnju',
    missing_fields: 'Popunite sva obavezna polja',
    missing_id: 'Nedostaje ID resursa',
    method_not_allowed: 'Akcija nije dozvoljena',
    invalid_group: 'Izabrana grupa nije validna',
    invalid_device: 'To vozilo vam nije dostupno',
    invalid_category: 'Ta kategorija nije dostupna',
    category_in_use: 'Kategorija se koristi ili ta šifra već postoji',
    recurrence_in_use: 'Ovo pravilo je već generiralo troškove i ne može se obrisati',
    cost_locked: 'Ovaj trošak je zaključen. Samo ga administrator može otključati.',
    invalid_rule: 'Pravilo ponavljanja je nepotpuno ili neispravno',
    readonly_field: 'Polje samo za čitanje ne može se mijenjati',
    server_error: 'Poslužitelj nije mogao spremiti promjenu. Ništa nije spremljeno.',
    request_failed: 'Zahtjev nije uspeo. Pokušajte ponovo.',
    invalid_request: 'Neispravan format zahtjeva',
    invalid_response: 'Neočekivan odgovor servera',
    range_too_long: 'Razdoblje može biti najviše 31 dan.',
    invalid_file: 'Vrsta ili veličina datoteke nisu dopušteni',
    too_many_files: 'Ovaj trošak već ima najviše 10 datoteka',
    upload_missing: 'Učitavanje nije dovršeno. Pokušajte ponovno.',
    s3_EntityTooLarge: 'Datoteka je veća od 20 MB',
    s3_AccessDenied: 'Poveznica za učitavanje je istekla. Pokušajte ponovno.',
    invalid_schedule: 'Raspored je nepotpun ili neispravan',
    invalid_recipients: 'Jedna ili više e-mail adresa nisu ispravne',
    too_many_recipients: 'Raspored može imati najviše 10 primatelja',
    invalid_timezone: 'Nepoznata vremenska zona',
    schedule_limit: 'Dosegnuli ste najviše 20 zakazanih izvješća',
    too_many_requests: 'Pričekajte minutu prije ponovnog slanja',
  },

  // Live Tracking
  tracking: {
    vehicles: 'Vozila',
    searchVehicles: 'Pretraži vozila...',
    visible: 'Vidljivo',
    moving: 'U pokretu',
    idle: 'Miruje',
    stopped: 'Zaustavljeno',
    offline: 'Van mreže',
    following: 'Praćenje',
    speed: 'Brzina',
    altitude: 'Visina',
    satellites: 'Sateliti',
    fuelLevel: 'Razina goriva',
    fuelUsed: 'Potrošeno goriva',
    distance: 'Udaljenost',
    engineTemp: 'Temp. motora',
    rpm: 'Obrtaji',
    heading: 'Smjer',
    fuel: 'Gorivo',
    ignition: 'Paljenje',
    on: 'Uključeno',
    off: 'Isključeno',
    sensors: 'Senzori',
    history: 'Povijest',
    settings: 'Postavke',
    trackVehicle: 'Prati ovo vozilo',
    stopTracking: 'Zaustavi praćenje',
    hideDetails: 'Sakrij detalje',
    showDetails: 'Prikaži detalje',
    noCoordinates: 'Nema koordinata (skriveno na mapi)',
    withoutCoordinates: 'Bez koordinata',
    isolateStatusHint: 'Dvoklik prikazuje samo ovaj status',
    overview: 'Pregled',
    general: 'Opšte',
    sentData: 'Poslati podaci',
    reports: 'Izvješća',
    lastUpdate: 'Posljednje ažuriranje',
    lastUpdateUnderMinute: '<1 min',
    lastUpdateMinutesUnit: 'min',
    latestInputs: 'Najnoviji ulazi',
    noSensorData: 'Nema podataka sa senzora',
    openReportsForVehicle: 'Otvori izveštaje filtrirane za ovo vozilo.',
    openReports: 'Otvori izveštaje',
    followingGroup: 'Praćenje grupe',
    make: 'Marka',
    model: 'Model',
    year: 'Godina',
    registration: 'Registracija',
    deviceId: 'ID uređaja',
    noData: 'Nema podataka',
    viewHistory: 'Pogledaj povijest vozila',
    driver: 'Vozač',
    goToHistory: 'Idi na povijest',
    vehicleTable: 'Tablica vozila',
    vehicleTableDesc: 'Sva vozila s najnovijom telemetrijom, grupirana po grupi vozila.',
  },

  // Map
  map: {
    street: 'Ulična',
    muted: 'Prigušena',
    satellite: 'Satelitska',
    dark: 'Tamna',
    terrain: 'Teren',
  },

  // History
  historyPage: {
    title: 'Povijest i izvješća',
    subtitle: 'Pregled povijesti putovanja, ruta i događaja',
    group: 'Grupa',
    allGroups: 'Sve grupe',
    vehicle: 'Vozilo',
    allVehicles: 'Sva vozila',
    period: 'Period',
    startTime: 'Vrijeme početka',
    endTime: 'Vrijeme završetka',
    invalidDateRange: 'Datum i vrijeme završetka moraju biti nakon datuma i vremena početka.',
    loadHistory: 'Učitaj povijest',
    filtersChanged: 'Filteri su promijenjeni. Kliknite “Učitaj povijest” za osvježavanje.',
    loadHistoryPrompt: 'Postavite filtere i kliknite “Učitaj povijest” za prikaz putovanja.',
    trips: 'Putovanja',
    distance: 'Udaljenost',
    distanceTotal: 'Ukupna udaljenost',
    fuelTotal: 'Ukupno gorivo',
    avgSpeed: 'Prosječna brzina',
    events: 'Događaji',
    distanceByDay: 'Udaljenost po danu',
    eventsByType: 'Događaji po tipu',
    noEvents: 'Nema događaja u izabranom periodu',
    /** Keyed by the upstream `has_<type>` suffix; unknown types fall back to a humanized label. */
    routeEvents: {
      speeding: 'Prekoračenje brzine vozila',
      street_speeding: 'Prekoračenje ograničenja',
      fuel_drain: 'Istakanje goriva',
      refuel: 'Tankanje goriva',
      parking_zone_changed: 'Promjena parking zone',
      go_zone_changed: 'Promjena zone vožnje',
      nogo_zone_changed: 'Promjena zabranjene zone',
    },
    start: 'Početak',
    end: 'Kraj',
    duration: 'Trajanje',
    viewRoute: 'Prikaži rutu',
    route: 'Ruta',
    maxSpeed: 'Maks. brzina',
    speedViolation: 'Prekoračenje brzine',
    harshBrake: 'Naglo kočenje',
    harshAcceleration: 'Naglo ubrzanje',
    idle: 'Mirovanje',
    fuel: 'Gorivo',
    fuelConsumed: 'Utrošeno gorivo',
    avgConsumption: 'Prosječna potrošnja',
    geofence: 'Geofence',
    routeStop: 'Zaustavljanje',
    groupBy: 'Grupiranje',
    groupByNone: 'Bez grupiranja',
    groupByDateVehicle: 'Datum → Vozilo',
    groupByVehicleDate: 'Vozilo → Datum',
    continued: 'nastavak',
    tooManyRoutes: 'ruta učitano — prikaz može biti spor. Suzite vremensko razdoblje ili odaberite manje vozila.',
    statsToggle: 'Statistika',
    showChart: 'Prikaži grafikon',
    hideChart: 'Sakrij grafikon',
    exportMapPdf: 'Izvezi kartu (PDF)',
    mapExportTitle: 'Karta rute',
    pointReadout: 'Vrijednosti u označenoj točki',
    pointTime: 'Vrijeme',
  },

  // Vehicles
  vehiclesPage: {
    title: 'Vozila',
    subtitle: 'Upravljanje vozilima i podešavanjima flote',
    addVehicle: 'Dodaj vozilo',
    addNewVehicle: 'Dodaj novo vozilo',
    addNewVehicleDesc: 'Dodajte novo vozilo u vašu flotu',
    vehicleName: 'Naziv vozila',
    plateNumber: 'Registracija',
    deviceId: 'ID',
    selectGroup: 'Izaberite grupu',
    selectDriver: 'Odaberite vozača',
    noDriver: 'Bez vozača',
    driverAlreadyAssignedTitle: 'Vozač je već dodijeljen',
    driverAlreadyAssignedDesc: 'Ovaj vozač je već dodijeljen vozilima ispod. Nastavak zadržava te dodjele i dodaje ovu.',
    driverName: 'Ime vozača',
    totalVehicles: 'Ukupno vozila',
    vehicleGroups: 'Grupe vozila',
    allVehicles: 'Sva vozila',
    odometer: 'Kilometraža',
    tankCapacity: 'Kapacitet spremnika (L)',
    make: 'Marka',
    model: 'Model',
    year: 'Godište',
    vehicleUpdated: 'Vozilo je ažurirano',
    maxSpeed: 'Maksimalna brzina',
    trackSpeeding: 'Prati maks. brzinu vozila',
    trackStreetSpeeding: 'Prati ograničenje na ulici',
    speedControl: 'Kontrola brzine',
    editSelected: 'Uredi odabrana',
    selectedCount: '{count} odabrano',
    bulkEditTitle: 'Uređivanje odabranih vozila',
    bulkEditDesc: 'Samo polja koja omogućite ispod bit će promijenjena na odabranim vozilima.',
    changeField: 'Promijeni ovo polje',
    clearSelection: 'Poništi odabir',
    bulkUpdated: '{count} vozila ažurirano',
    bulkUpdatedPartial: '{updated} ažurirano, {failed} neuspješno',
    allGroups: 'Sve grupe',
    addService: 'Dodaj servis',
    vehicleSettings: 'Postavke',
    vehicleActions: 'Radnje vozila',
  },

  // Drivers
  driversPage: {
    title: 'Vozači',
    subtitle: 'Upravljanje vozačima i dodelama vozila',
    addDriver: 'Dodaj vozača',
    addNewDriver: 'Dodaj novog vozača',
    addNewDriverDesc: 'Dodajte novog vozača u vašu flotu',
    editDriver: 'Uredi vozača',
    editDriverDesc: 'Ažurirajte informacije o vozaču',
    fullName: 'Ime i prezime',
    phone: 'Telefon',
    rfid: 'RFID',
    license: 'Dozvola',
    licenseNumber: 'Broj dozvole',
    licenseExpiry: 'Datum isteka dozvole',
    address: 'Adresa',
    city: 'Grad',
    zip: 'Poštanski broj',
    expires: 'Ističe',
    assignedVehicle: 'Dodijeljeno vozilo',
    assignVehicle: 'Dodijeli vozilo',
    selectVehicle: 'Odaberi vozilo',
    status: 'Status',
    active: 'Aktivan',
    inactive: 'Neaktivan',
    onLeave: 'Na odsustvu',
    unassigned: 'Nedodeljen',
    totalDrivers: 'Ukupno vozača',
    assigned: 'Dodijeljeno',
    allDrivers: 'Svi vozači',
    saveChanges: 'Spremi izmene',
    driverAdded: 'Vozač uspješno dodat',
    driverUpdated: 'Vozač uspješno ažuriran',
    driverDeleted: 'Vozač uspješno obrisan',
    assignedVehicles: 'Dodijeljena vozila',
    assignmentUpdated: 'Dodjela vozila ažurirana',
    firstNamePlaceholder: 'Marko',
    lastNamePlaceholder: 'Marković',
  },

  // Zones
  zonesPage: {
    title: 'Zone',
    subtitle: 'Upravljanje geofence zonama za vašu flotu',
    drawZone: 'Nacrtaj zonu',
    undoPoint: 'Poništi tačku',
    points: 'tačaka',
    totalZones: 'Ukupno zona',
    parking: 'Parking',
    noGo: 'Zabranjena',
    driving: 'Vožnja',
    custom: 'Prilagođena',
    parkingZone: 'Parking zona',
    noGoZone: 'Zabranjena zona',
    drivingZone: 'Zona vožnje',
    customZone: 'Prilagođena zona',
    zoneMap: 'Mapa zona',
    zoneList: 'Lista zona',
    createZone: 'Kreiraj zonu',
    createZoneDesc: 'Imenujte i konfigurišite vašu novu zonu',
    editZone: 'Uredi zonu',
    editZoneDesc: 'Ažurirajte postavke zone',
    zoneName: 'Naziv zone',
    zoneType: 'Tip zone',
    clickToAdd: 'Kliknite na mapu da dodate tačke',
    noZones: 'Nema kreiranih zona. Kliknite "Nacrtaj zonu" da kreirate.',
    zoneCreated: 'Zona uspješno kreirana',
    zoneUpdated: 'Zona uspješno ažurirana',
    zoneDeleted: 'Zona uspješno obrisana',
    needMorePoints: 'Zona zahtijeva najmanje 3 tačke',
    zoneNamePlaceholder: 'npr. Glavni parking',
    shape: 'Oblik',
    clearPoints: 'Obriši tačke',
    pointLabel: 'Tačka',
    noPointsYet: 'Kliknite na mapu da postavite prvu tačku obrisa zone.',
    drawInstructions: 'Nastavite klikati na mapu da dodate tačke. Koristite Poništi ili Obriši za ispravak.',
    zoneDescription: 'Opis',
    zoneDescriptionPlaceholder: 'Opcionalne napomene o zoni',
  },

  // POI
  poiPage: {
    title: 'Tačke interesa',
    subtitle: 'Upravljanje lokacijama i kontaktima',
    addPoi: 'Dodaj POI',
    addPoiTitle: 'Dodaj tačku interesa',
    addPoiDesc: 'Dodajte novu lokaciju na vašu mapu',
    editPoiTitle: 'Uredi tačku interesa',
    editPoiDesc: 'Ažurirajte informacije o POI',
    total: 'Ukupno',
    partner: 'Partner',
    gasStation: 'Benzinska postaja',
    warehouse: 'Skladište',
    customer: 'Kupac',
    serviceCenter: 'Servisni centar',
    other: 'Ostalo',
    poiMap: 'POI mapa',
    poiList: 'POI lista',
    name: 'Naziv',
    type: 'Tip',
    address: 'Adresa',
    latitude: 'Geografska širina',
    longitude: 'Geografska dužina',
    clickToSelect: 'Kliknite na mapu da odaberete lokaciju',
    contactPerson: 'Kontakt osoba',
    contactPhone: 'Kontakt telefon',
    contactEmail: 'Kontakt email',
    description: 'Opis',
    descriptionPlaceholder: 'Opcionalni opis ove lokacije',
    notes: 'Napomene',
    additionalNotes: 'Dodatne napomene...',
    noPois: 'Nema kreiranih POI. Kliknite "Dodaj POI" da kreirate.',
    poiAdded: 'POI uspješno dodat',
    poiUpdated: 'POI uspješno ažuriran',
    poiDeleted: 'POI uspješno obrisan',
    namePlaceholder: 'npr. Glavna kancelarija',
    addressPlaceholder: 'Glavna 123, Grad',
    contactPersonPlaceholder: 'Petar Petrović',
    contactPhonePlaceholder: '+381 60 123 4567',
    contactEmailPlaceholder: 'kontakt@firma.rs',
    location: 'Lokacija',
    dragMarkerHint: 'Povucite marker ili kliknite na mapu da ga pomaknete.',
  },

  // Reports
  reportsPage: {
    title: 'Izvješća',
    subtitle: 'Generišite i izvezite prilagođene izveštaje flote',
    generateReport: 'Generiraj izvješće',
    filtersChanged: 'Filteri su promijenjeni. Kliknite “Generiraj izvješće” za osvježavanje.',
    reportType: 'Tip izveštaja',
    tripReport: 'Izvješće o putovanjima',
    fuelReport: 'Izvješće o gorivu',
    driverReport: 'Izvješće o vozačima',
    vehicleUtilization: 'Iskorišćenost vozila',
    dateRange: 'Opseg datuma',
    pickDateRange: 'Izaberite opseg datuma',
    invalidDateRange: 'Datum i vrijeme završetka moraju biti nakon datuma i vremena početka.',
    tripReportDesc: 'Retci putovanja iz API povijesti ruta: tablice, segmenti, udaljenosti, brzine, broj uzoraka',
    fuelReportDesc: 'Tankanja goriva po vozilu: koliko puta, koliko ukupno i kada je posljednje',
    driverReportDesc: 'Ukupni podaci po vozaču iz povijesti ruta (udaljenost, vrijeme, brzine) i vožena vozila',
    vehicleReportDesc: 'Ukupni podaci po vozilu iz povijesti ruta (udaljenost, vrijeme, brzine) plus dodijeljena grupa',
    startTime: 'Vrijeme početka',
    endTime: 'Vrijeme završetka',
    refuelCount: 'Broj tankanja',
    refuelledTotalL: 'Ukupno natočeno (L)',
    lastRefuel: 'Posljednje tankanje',
    drainCount: 'Broj istakanja',
    startLocation: 'Početna lokacija',
    endLocation: 'Krajnja lokacija',
    distanceKm: 'Udaljenost (km)',
    durationMin: 'Trajanje (min)',
    avgSpeedKmh: 'Prosječna brzina (km/h)',
    fuelL: 'Utrošeno gorivo (L)',
    avgConsumption: 'Prosječna potrošnja',
    routeNo: 'Ruta br.',
    pointsCount: 'Uzorkovanih točaka',
    totalDurationMinutes: 'Ukupno trajanje (min)',
    totalDurationHms: 'Ukupno trajanje (hh:mm:ss)',
    dateTime: 'Datum/Vrijeme',
    location: 'Lokacija',
    odometerKm: 'Kilometraža (km)',
    driver: 'Vozač',
    totalTrips: 'Ukupno putovanja',
    totalDistanceKm: 'Ukupno udaljenost (km)',
    group: 'Grupa',
    fuelLevelPercent: 'Nivo goriva (%)',
    showingFirst: 'Prikazano prvih',
    ofRecords: 'zapisa. Izvezite da vidite sve podatke.',
    allTime: 'Cijeli period',
    refuel: 'Tankanje',
    consumption: 'Potrošnja',
    theft: 'Krađa',
  },

  // Notifications
  notificationsPage: {
    settings: 'Postavke obavijesti',
    title: 'Obavijesti',
    unreadNotifications: 'nepročitanih obavijesti',
    allCaughtUp: 'Sve ste pročitali!',
    markAllRead: 'Označi sve kao pročitano',
    total: 'Ukupno',
    alerts: 'Uzbune',
    warnings: 'Upozorenja',
    unread: 'Nepročitano',
    noNotifications: 'Nema obavijesti',
    youreAllCaughtUp: 'Sve ste pročitali!',
  },

  // Live vehicle events (docs/Events.MD) and their toast preferences
  vehicleEvents: {
    types: {
      parking_enter: 'Vozilo je ušlo u parkirnu zonu',
      parking_exit: 'Vozilo je napustilo parkirnu zonu',
      go_zone_enter: 'Vozilo je ušlo u dopuštenu zonu',
      go_zone_exit: 'Vozilo je napustilo dopuštenu zonu',
      nogo_zone_enter: 'Vozilo je ušlo u zabranjenu zonu',
      nogo_zone_exit: 'Vozilo je napustilo zabranjenu zonu',
      driver_identified: 'Vozač identificiran',
      driver_removed: 'Vozač uklonjen',
      driver_changed: 'Vozač promijenjen',
      started: 'Motor upaljen',
      stopped: 'Motor ugašen',
      speeding_start: 'Vozilo je prekoračilo brzinu (ograničenje vozila)',
      speeding_end: 'Vozilo je ponovno ispod ograničenja vozila',
      street_speeding_start: 'Vozilo je prekoračilo ograničenje na cesti',
      street_speeding_end: 'Vozilo je ponovno ispod ograničenja na cesti',
      refuel: 'Točenje goriva',
      missing_fuel: 'Pad razine goriva',
      overheat: 'Pregrijavanje motora',
    },
    categories: {
      zone: 'Zone',
      driver: 'Vozač',
      engine: 'Motor',
      speed: 'Brzina',
      fuel: 'Gorivo',
    },
    prefsTitle: 'Skočne obavijesti',
    prefsHint: 'Odaberite koji događaji vozila iskaču. Događaji koji iskoče čuvaju se i u popisu obavijesti.',
    savedInstantly: 'Promjene se spremaju čim promijenite prekidač.',
    toggleAll: 'Sve',
    muteSound: 'Isključi zvuk',
    unmuteSound: 'Uključi zvuk',
    newNotifications: 'novih obavijesti',
    view: 'Prikaži',
    vehicle: 'Vozilo',
    zone: 'Zona',
    limit: 'ograničenje',
  },

  // User Settings
  usersPage: {
    title: 'Korisnici',
    subtitle: 'Upravljanje korisnicima klijenta i dodeljenim grupama',
    addUser: 'Dodaj korisnika',
    editUser: 'Uredi korisnika',
    addUserDesc: 'Kreirajte novi korisnički nalog',
    editUserDesc: 'Ažurirajte podatke korisnika i pristup grupama',
    fullName: 'Ime i prezime',
    username: 'Korisničko ime',
    password: 'Lozinka',
    passwordOptional: 'Lozinka (ostavite prazno da ostane trenutna)',
    email: 'Email',
    phone: 'Telefon',
    groups: 'Grupe',
    noGroups: 'Nema dostupnih grupa',
    selectedGroups: 'Izabrane grupe',
    totalUsers: 'Ukupno korisnika',
    allUsers: 'Svi korisnici',
    userAdded: 'Korisnik je uspješno kreiran',
    userUpdated: 'Korisnik je uspješno ažuriran',
    userDeleted: 'Korisnik je uspješno obrisan',
    assignedGroups: 'Dodeljene grupe',
    noAssignedGroups: 'Nema dodijeljenih grupa',
    fullNamePlaceholder: 'Petar Petrović',
    usernamePlaceholder: 'petar.petrovic',
    emailPlaceholder: 'petar@firma.rs',
    phonePlaceholder: '+381 60 123 4567',
  },

  // User Settings
  userSettingsPage: {
    title: 'Postavke korisnika',
    subtitle: 'Upravljajte vašim nalogom i preferencama',
    profile: 'Profil',
    profileDesc: 'Vaši lični podaci',
    fullName: 'Ime i prezime',
    email: 'Email',
    phone: 'Telefon',
    role: 'Uloga',
    saveChanges: 'Spremi izmene',
    notifications: 'Obavijesti',
    notificationsDesc: 'Konfigurišite kako primate obavijesti',
    emailNotifications: 'Email obavijesti',
    emailNotificationsDesc: 'Primajte obavijesti putem emaila',
    pushNotifications: 'Push obavijesti',
    pushNotificationsDesc: 'Primajte push obavijesti u pregledniku',
    alertTypes: 'Tipovi upozorenja',
    speedViolations: 'Prekoračenje brzine',
    fuelAlerts: 'Upozorenja o gorivu',
    geofenceAlerts: 'Geofence upozorenja',
    maintenanceReminders: 'Podsetnici za održavanje',
    preferences: 'Preference',
    preferencesDesc: 'Prilagodite vaše iskustvo',
    language: 'Jezik',
    timezone: 'Vremenska zona',
    distanceUnit: 'Jedinica rastojanja',
    kilometers: 'Kilometri',
    miles: 'Milje',
    dateFormat: 'Format datuma',
    savePreferences: 'Spremi preference',
    security: 'Sigurnost',
    securityDesc: 'Upravljajte sigurnošću vašeg naloga',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    updatePassword: 'Ažuriraj lozinku',
    settingsSaved: 'Postavke uspješno sačuvana',
    phonePlaceholder: '+381 60 123 4567',
    pacificTime: 'Pacifičko vrijeme (UTC-8)',
    easternTime: 'Istočno vrijeme (UTC-5)',
    centralEuropeanTime: 'Srednjoeuropsko vrijeme (UTC+1)',
    dateFormatMdy: 'MM/DD/GGGG',
    dateFormatDmy: 'DD/MM/GGGG',
    dateFormatYmd: 'GGGG-MM-DD',
    utc: 'UTC',
  },

  // System Settings
  systemSettingsPage: {
    title: 'Sistemske postavke',
    subtitle: 'Konfigurišite globalne sistemske preference',
    mapSettings: 'Postavke mape',
    mapSettingsDesc: 'Konfigurišite prikaz i ponašanje mape',
    refreshInterval: 'Interval osvežavanja (sekunde)',
    showTrafficLayer: 'Prikaži sloj prometa',
    showTrafficDesc: 'Prikaz podataka o saobraćaju u realnom vremenu',
    satelliteView: 'Satelitski prikaz',
    satelliteViewDesc: 'Koristi satelitske snimke',
    clusterMarkers: 'Grupiši markere',
    clusterMarkersDesc: 'Grupiši bliska vozila kada se umanji prikaz',
    alertThresholds: 'Pragovi upozorenja',
    alertThresholdsDesc: 'Postavite pragove za automatska upozorenja',
    speedLimitKmh: 'Ograničenje brzine (km/h)',
    idleTimeoutMin: 'Timeout mirovanja (minuti)',
    lowFuelThreshold: 'Prag niskog nivoa goriva (%)',
    geofenceAlerts: 'Geofence upozorenja',
    geofenceAlertsDesc: 'Upozori kada vozila napuste određene zone',
    saveAlertSettings: 'Spremi postavke upozorenja',
    notificationDelivery: 'Dostava obavijesti',
    notificationDeliveryDesc: 'Konfigurišite kako se obavijesti šalju korisnicima',
    emailServer: 'Email server (SMTP)',
    smtpPort: 'SMTP port',
    fromEmail: 'Email pošiljaoca',
    replyToEmail: 'Reply-to email',
    saveNotificationSettings: 'Spremi postavke obavijesti',
    dataRetention: 'Čuvanje podataka',
    dataRetentionDesc: 'Konfigurišite politike čuvanja i čišćenja podataka',
    gpsHistoryRetention: 'Čuvanje GPS povijesti',
    tripHistoryRetention: 'Čuvanje povijesti putovanja',
    alertHistoryRetention: 'Čuvanje povijesti upozorenja',
    backupFrequency: 'Učestalost rezervnih kopija',
    days: 'dana',
    year: '1 godina',
    years: '2 godine',
    hourly: 'Svaki sat',
    daily: 'Dnevno',
    weekly: 'Tjedno',
    saveRetentionSettings: 'Spremi postavke čuvanja',
    apiIntegrations: 'API i integracije',
    apiIntegrationsDesc: 'Upravljajte API ključevima i integracijama sa trećim stranama',
    apiKey: 'API ključ',
    regenerate: 'Ponovno generiraj',
    apiKeyDesc: 'Koristite ovaj ključ za integraciju sa eksternim sistemima',
    webhookUrl: 'Webhook URL',
    webhookDesc: 'Događaji će biti poslati na ovaj URL u realnom vremenu',
    saveApiSettings: 'Spremi API postavke',
    systemSettingsSaved: 'Sistemske postavke uspješno sačuvane',
    emailServerPlaceholder: 'smtp.firma.rs',
    smtpPortPlaceholder: '587',
    fromEmailPlaceholder: 'obavestenja@firma.rs',
    replyToEmailPlaceholder: 'podrska@firma.rs',
    webhookUrlPlaceholder: 'https://api.vasafirma.com/webhooks/fleet',
  },

  // Groups
  groupsPage: {
    title: 'Grupe vozila',
    subtitle: 'Organizujte vašu flotu u logičke grupe',
    addGroup: 'Dodaj grupu',
    addNewGroup: 'Dodaj novu grupu',
    addNewGroupDesc: 'Kreirajte novu grupu vozila za vašu flotu',
    groupName: 'Naziv grupe',
    groupNamePlaceholder: 'Unesite naziv grupe...',
    groupColor: 'Boja grupe',
    totalGroups: 'Ukupno grupa',
    avgVehiclesPerGroup: 'Prosečno po grupi',
    allGroups: 'Sve grupe',
    allGroupsDesc: 'Upravljajte vašim grupama vozila i njihovim podešavanjima',
    vehiclesAssigned: 'dodijeljenih vozila',
    editGroup: 'Uredi grupu',
    editGroupDesc: 'Ažurirajte naziv i boju grupe',
    groupAdded: 'Grupa dodata',
    groupAddedDesc: 'Grupa vozila je uspješno kreirana.',
    groupUpdated: 'Grupa ažurirana',
    groupUpdatedDesc: 'Grupa vozila je uspješno ažurirana.',
    groupDeleted: 'Grupa obrisana',
    groupDeletedDesc: 'Grupa vozila je obrisana.',
    cannotDelete: 'Nije moguće obrisati grupu',
    groupHasVehicles: 'Ova grupa još uvijek ima dodeljena vozila.',
  },

  // Costs
  costsPage: {
    title: 'Troškovi',
    subtitle: 'Troškovi vozila, ponavljajući rasporedi i nadolazeći podsjetnici',
    tabOverview: 'Pregled',
    tabCosts: 'Troškovi',
    tabRecurrences: 'Ponavljanja',
    tabUpcoming: 'Nadolazeće',
    addCost: 'Dodaj trošak',
    addCostDesc: 'Evidentiraj novi trošak za vozilo',
    editCost: 'Uredi trošak',
    editCostDesc: 'Ažuriraj zapis o trošku',
    saveChanges: 'Spremi promjene',
    vehicle: 'Vozilo',
    category: 'Kategorija',
    date: 'Datum',
    amount: 'Iznos',
    currency: 'Valuta',
    costTitle: 'Naziv',
    description: 'Opis',
    odometer: 'Kilometraža',
    planned: 'Planiran',
    unplanned: 'Neplaniran',
    status: 'Status',
    vendor: 'Dobavljač',
    invoiceNo: 'Broj računa',
    documentUrl: 'Poveznica na dokument',
    statusPlanned: 'Planiran',
    statusDone: 'Realiziran',
    statusCancelled: 'Otkazan',
    statusInProgress: 'U tijeku',
    selectVehicle: 'Odaberi vozilo',
    selectCategory: 'Odaberi kategoriju',
    searchCategories: 'Pretraži kategorije...',
    noCategoriesFound: 'Nema pronađenih kategorija',
    allCategories: 'Sve kategorije',
    allStatuses: 'Svi statusi',
    allVehicles: 'Sva vozila',
    useCurrentOdometer: 'Koristi trenutno stanje',
    totalCost: 'Potrošeno',
    plannedTotal: 'Planirano',
    unplannedTotal: 'Neplanirano',
    costCount: 'Zapisa',
    forecastTotal: 'Prognoza',
    markDone: 'Označi kao realizirano',
    completeCost: 'Potvrdi trošak',
    completeCostDesc: 'Unesite stvarni datum, kilometražu i iznos. Sljedeće dospijeće računa se od njih.',
    costCompleted: 'Trošak označen kao realiziran',
    anchorHint: 'Kada je ovo zadnji put napravljeno. Sljedeće dospijeće i kilometraža računaju se od toga.',
    recurrenceInUse: 'Ovo pravilo je već generiralo troškove pa se ne može obrisati. Deaktivirajte ga kako biste zaustavili podsjetnike.',
    deactivate: 'Deaktiviraj',
    recurrenceDeactivated: 'Pravilo deaktivirano',
    recurrenceHistoryDesc: 'Tko je izradio i mijenjao ovo pravilo te troškovi koje je generiralo',
    readOnlyNotice: 'Možete pregledavati troškove, ali ih ne možete mijenjati',
    startCost: 'Započni trošak',
    startCostDesc: 'Otvorite trošak samo s vozilom. Nadopunjujte opis kako posao napreduje, a na kraju unesite cijenu i zaključite ga.',
    closeCost: 'Zaključi trošak',
    closeCostDesc: 'Unesite konačan iznos, datum i kilometražu. Nakon zaključivanja samo administrator može otključati trošak.',
    closeConfirmTitle: 'Zaključiti trošak?',
    closeConfirm: 'Nakon zaključivanja trošak je zaključan i samo ga administrator može otključati.',
    costClosed: 'Trošak zaključen',
    unlockCost: 'Otključaj',
    unlockConfirmTitle: 'Otključati trošak?',
    unlockConfirm: 'Trošak se vraća u status „U tijeku” i može se ponovno mijenjati. Otključavanje se bilježi u povijesti.',
    costUnlocked: 'Trošak otključan',
    costLockedNotice: 'Ovaj trošak je zaključen. Samo ga administrator može otključati.',
    progressNotesHint: 'Što je dosad napravljeno — nadopunjujte kako posao napreduje',
    costPerKm: 'Trošak po km',
    byCategory: 'Po kategoriji',
    byVehicle: 'Vozila s najvećim troškom',
    overTime: 'Kroz vrijeme',
    noChartData: 'Nema troškova u odabranom razdoblju',
    addRecurrence: 'Dodaj pravilo',
    addRecurrenceDesc: 'Izradi raspored ponavljajućeg troška',
    editRecurrence: 'Uredi pravilo',
    editRecurrenceDesc: 'Ažuriraj raspored ponavljajućeg troška',
    ruleType: 'Ponavlja se',
    ruleInterval: 'Svako razdoblje',
    ruleIntervalDesc: 'Godišnja registracija, mjesečni leasing',
    ruleMileage: 'Na prijeđene km',
    ruleMileageDesc: 'Servis ulja svakih 15.000 km',
    ruleIntervalAndMileage: 'Km ili razdoblje',
    ruleIntervalAndMileageDesc: 'Što god prvo nastupi',
    ruleFixedDates: 'Fiksni datumi',
    ruleFixedDatesDesc: 'Ljetne i zimske gume',
    intervalValue: 'Svakih',
    intervalUnit: 'Jedinica',
    unitDay: 'Dana',
    unitMonth: 'Mjeseci',
    unitYear: 'Godina',
    mileageInterval: 'Svakih (km)',
    fixedDates: 'Datumi',
    addFixedDate: 'Dodaj datum',
    anchorDate: 'Počevši od',
    anchorOdometer: 'Početna kilometraža',
    estimatedAmount: 'Procijenjeni iznos',
    leadDays: 'Upozori dana ranije',
    leadKm: 'Upozori km ranije',
    ruleActive: 'Aktivno',
    rulePaused: 'Pauzirano',
    nextDue: 'Sljedeće dospijeće',
    nextDueOdometer: 'Dospijeva na',
    noRecurrences: 'Još nema ponavljajućih troškova',
    upcomingTitle: 'Nadolazeći troškovi',
    severityOverdue: 'Kasni',
    severityDueSoon: 'Uskoro dospijeva',
    severityUpcoming: 'Predstoji',
    daysLeft: 'dana preostalo',
    daysOverdue: 'dana kašnjenja',
    kmLeft: 'km preostalo',
    kmOverdue: 'km preko',
    logCost: 'Evidentiraj trošak',
    dismiss: 'Odbaci',
    noUpcoming: 'Ništa ne dospijeva',
    noUpcomingDesc: 'Nema troškova koji dospijevaju u ovom razdoblju',
    history: 'Povijest promjena',
    historyDesc: 'Tko je izradio i mijenjao ovaj trošak',
    noHistory: 'Još nema povijesti',
    logCreate: 'izradio',
    logUpdate: 'uredio',
    logDelete: 'obrisao',
    logGenerate: 'automatski generirano',
    logComplete: 'označio kao realiziran',
    systemUser: 'Sustav',
    notSet: 'nije postavljeno',
    tabDetails: 'Pojedinosti',
    logTime: 'Vrijeme',
    logUser: 'Korisnik',
    logAction: 'Radnja',
    logChanges: 'Izmjene',
    logField: 'Polje',
    logBefore: 'Prije',
    logAfter: 'Poslije',
    logNoChanges: 'Za ovaj unos nisu zabilježene izmjene polja',
    attachments: 'Datoteke',
    attachmentsDesc: 'Računi, fakture i fotografije za ovaj trošak',
    attachmentsQueuedDesc: 'Datoteke se učitavaju kada se trošak spremi',
    addFile: 'Dodaj datoteku',
    noAttachments: 'Nema priloženih datoteka',
    attachmentLimit: 'Trošak može imati najviše {count} datoteka',
    uploading: 'Učitavanje…',
    uploadFailed: 'Učitavanje nije uspjelo',
    retry: 'Pokušaj ponovno',
    remove: 'Ukloni',
    openAttachment: 'Otvori datoteku',
    deleteAttachment: 'Obriši datoteku',
    deleteAttachmentConfirm: 'Obrisati „{name}”? Ovo se ne može poništiti.',
    attachmentDeleted: 'Datoteka je obrisana',
    deleteCostTitle: 'Obrisati trošak?',
    deleteCostConfirm: 'Ovaj trošak bit će trajno obrisan.',
    deleteCostWithFiles: 'Ovaj trošak i njegove priložene datoteke ({count}) bit će trajno obrisani.',
    logAttachmentAdd: 'je dodao/la',
    logAttachmentDelete: 'je uklonio/la',
    logClose: 'je zaključio/la',
    logUnlock: 'je otključao/la',
    attachmentUnsupportedType: '„{name}” nije podržana vrsta datoteke (JPG, PNG, WebP, HEIC ili PDF)',
    attachmentTooLarge: '„{name}” je veća od 20 MB',
    attachmentEmpty: '„{name}” je prazna',
    attachmentsFailed: 'Trošak je spremljen, ali {count} datoteka nije učitano. Dodajte ih ponovno iz troška.',
    attachmentCountLabel: 'Priloženih datoteka: {count}',
    createdBy: 'Izradio',
    updatedBy: 'Posljednji put uredio',
    costAdded: 'Trošak je uspješno dodan',
    costUpdated: 'Trošak je uspješno uređen',
    costDeleted: 'Trošak je uspješno obrisan',
    recurrenceAdded: 'Pravilo je uspješno dodano',
    recurrenceUpdated: 'Pravilo je uspješno uređeno',
    recurrenceDeleted: 'Pravilo je uspješno obrisano',
    noCosts: 'Nema evidentiranih troškova',
    reportTitle: 'Izvješće o troškovima',
    reportSubtitle: 'Troškovi vozila za odabrano razdoblje',
  },

  // Activity log
  activityPage: {
    title: 'Dnevnik aktivnosti',
    subtitle: 'Što je svaki korisnik otvarao, preuzimao i mijenjao',
    user: 'Korisnik',
    allUsers: 'Svi korisnici',
    eventType: 'Radnja',
    allEventTypes: 'Sve radnje',
    resource: 'Područje',
    allResources: 'Sva područja',
    searchPlaceholder: 'Pretraga aktivnosti',
    eventLogin: 'Prijava',
    eventLogout: 'Odjava',
    eventPageView: 'Otvorena stranica',
    eventReportGenerate: 'Generirano izvješće',
    eventHistoryQuery: 'Pretraga povijesti',
    eventExportPdf: 'Izvoz u PDF',
    eventExportExcel: 'Izvoz u Excel',
    eventExportMapPdf: 'Izvoz karte u PDF',
    eventCreate: 'Kreirano',
    eventUpdate: 'Promijenjeno',
    eventDelete: 'Obrisano',
    resourceSession: 'Sesija',
    resourcePage: 'Stranica',
    resourceReport: 'Izvješće',
    resourceHistory: 'Povijest',
    resourceVehicle: 'Vozilo',
    resourceDriver: 'Vozač',
    resourceZone: 'Zona',
    resourcePoi: 'Tačka interesa',
    resourceGroup: 'Grupa',
    resourceUser: 'Korisnik',
    resourceCost: 'Trošak',
    resourceCostCategory: 'Kategorija troška',
    resourceCostRecurrence: 'Ponavljajući trošak',
    resourceScheduledReport: 'Zakazano izvješće',
    summaryTitle: 'Korisnici',
    summarySubtitle: 'Posljednja prijava i aktivnost u odabranom razdoblju',
    lastLogin: 'Posljednja prijava',
    lastActivity: 'Posljednja aktivnost',
    logins: 'Prijava',
    events: 'Događaja',
    neverLoggedIn: 'Nikada se nije prijavio',
    time: 'Vrijeme',
    action: 'Radnja',
    area: 'Područje',
    details: 'Detalji',
    path: 'Stranica',
    ipAddress: 'IP adresa',
    noActivity: 'Nema zabilježene aktivnosti',
    moreAvailable: 'Prikazani su samo najnoviji redci — suzite vremensko razdoblje da biste vidjeli stariju aktivnost.',
    notAuthorized: 'Samo za administratore',
    notAuthorizedDesc: 'Dnevnik aktivnosti dostupan je administratorima računa.',
    reportTitle: 'Izvješće o aktivnosti',
    reportSubtitle: 'Aktivnost korisnika za odabrano razdoblje',
  },

  scheduledReportsPage: {
    title: 'Zakazana izvješća',
    subtitle: 'Izvješća koja vam automatski stižu e-mailom, prema rasporedu',
    newSchedule: 'Novi raspored',
    editSchedule: 'Uredi raspored',
    empty: 'Još nema zakazanih izvješća',
    emptyDesc: 'Izradite raspored kako biste izvješće primali svaki dan, tjedan ili mjesec.',
    unavailable: 'Zakazana izvješća još nisu dostupna',
    unavailableDesc: 'Poslužitelj još ne podržava zakazana izvješća. Pokušajte kasnije.',
    name: 'Naziv',
    namePlaceholder: 'npr. Jučerašnja putovanja',
    reportType: 'Izvješće',
    group: 'Grupa',
    vehicle: 'Vozilo',
    frequency: 'Učestalost',
    daily: 'Dnevno',
    weekly: 'Tjedno',
    monthly: 'Mjesečno',
    sendTime: 'Vrijeme slanja',
    weekdays: 'Dani slanja',
    weekdaysHint: 'Ako nijedan dan nije odabran, šalje se svaki dan.',
    weekday: 'Dan u tjednu',
    monthDay: 'Dan u mjesecu',
    timeZone: 'Vremenska zona',
    language: 'Jezik e-maila',
    formats: 'Privici',
    formatPdf: 'PDF',
    formatXlsx: 'Excel',
    recipients: 'Primatelji',
    recipientsPlaceholder: 'ime@primjer.com',
    recipientsHint: 'Pritisnite Enter ili zarez za dodavanje adrese. Najviše 10.',
    removeRecipient: 'Ukloni {email}',
    active: 'Aktivno',
    schedule: 'Raspored',
    nextRun: 'Sljedeće slanje',
    lastRun: 'Posljednje slanje',
    never: 'Nikad',
    statusOk: 'Poslano',
    statusFailed: 'Neuspješno',
    statusRetrying: 'Ponovni pokušaj',
    periodDaily: 'Svaki e-mail obuhvaća prethodni dan.',
    periodWeekly: 'Svaki e-mail obuhvaća prethodni tjedan, od ponedjeljka do nedjelje.',
    periodMonthly: 'Svaki e-mail obuhvaća prethodni kalendarski mjesec.',
    summaryDaily: 'Svaki dan u {time}',
    summaryDailyDays: '{days} u {time}',
    summaryWeekly: 'Svaki {day} u {time}',
    summaryMonthly: 'Mjesečno, {day}. u mjesecu u {time}',
    nextSendPreview: 'Sljedeće slanje: {date}',
    sendNow: 'Pošalji sada',
    sendNowQueued: 'Izvješće je u redu za slanje i trebalo bi stići za nekoliko minuta.',
    runHistory: 'Povijest slanja',
    noRuns: 'Ovaj raspored još ništa nije poslao.',
    runTime: 'Vrijeme',
    runStatus: 'Status',
    runRows: 'Zapisi',
    runRecipients: 'Primatelji',
    runError: 'Greška',
    runTrigger: 'Pokretanje',
    triggerSchedule: 'Prema rasporedu',
    triggerManual: 'Ručno',
    deleteTitle: 'Izbrisati zakazano izvješće?',
    deleteDescription: '"{name}" se više neće slati i bit će trajno izbrisano.',
    created: 'Zakazano izvješće je izrađeno',
    updated: 'Zakazano izvješće je ažurirano',
    deleted: 'Zakazano izvješće je izbrisano',
    activated: 'Raspored je uključen',
    deactivated: 'Raspored je isključen',
    scheduleThisReport: 'Zakaži',
    nameRequired: 'Unesite naziv',
    formatRequired: 'Odaberite barem jedan privitak',
    recipientsRequired: 'Dodajte barem jednog primatelja',
    weekdayRequired: 'Odaberite dan u tjednu',
    invalidTime: 'Unesite vrijeme u obliku HH:MM',
    actions: 'Radnje',
  },

  scheduledReportEmail: {
    subject: '{report}: {period}',
    intro: 'U privitku je vaše zakazano izvješće "{name}".',
    report: 'Izvješće',
    period: 'Razdoblje',
    scope: 'Vozila',
    records: 'Zapisi',
    noData: 'U ovom razdoblju nije zabilježena nikakva aktivnost.',
    footer: 'Ovaj e-mail automatski je poslao {app}. Za izmjenu ili zaustavljanje otvorite Postavke → Zakazana izvješća.',
  },

  // Toasts
  toast: {
    welcomeBack: 'Dobrodošli nazad!',
  },
};
